import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import EfSpec from '@elem/ui/ef-spec';
import { useLang } from '@/i18n';
import FreeQuoteCard from './FreeQuoteCard.client';
import './index.scss';

const IconEmail = () => (
    <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.9165 1.56494C6.13971 1.56494 1.45642 6.5975 1.45642 12.8052C1.45642 19.0128 6.13971 24.0454 11.9165 24.0454C17.6934 24.0454 22.3767 19.0128 22.3767 12.8052C22.3767 6.5975 17.6934 1.56494 11.9165 1.56494ZM17.3168 16.1904C17.3168 16.8109 16.831 17.3187 16.2369 17.3187H7.59618C7.00214 17.3187 6.51623 16.8109 6.51623 16.1904L6.52118 10.6161L11.7871 13.6169C11.827 13.6396 11.8714 13.6514 11.9165 13.6514C11.9616 13.6514 12.0061 13.6396 12.046 13.6169L17.3168 10.6132V16.1904ZM11.9192 12.5574L6.52179 9.40963C6.52703 8.79377 7.00563 8.29165 7.59621 8.29165H16.2369C16.8266 8.29165 17.3099 8.79189 17.3169 9.4065L11.9192 12.5574H11.9192Z"
            fill="white"
        />
    </svg>
);

const IconPhone = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.1395 1.61816C6.32869 1.61816 1.61864 6.32822 1.61864 12.139C1.61864 17.9498 6.32869 22.6599 12.1395 22.6599C17.9503 22.6599 22.6603 17.9498 22.6603 12.139C22.6603 6.32822 17.9503 1.61816 12.1395 1.61816ZM16.3268 18.0392C16.3103 18.0432 16.2722 18.0498 16.2025 18.0498C15.3365 18.0498 12.6537 17.1555 9.88803 14.3911C6.79884 11.3033 6.12485 8.41003 6.23203 7.94909C6.49308 6.82401 7.56226 6.22761 7.91931 6.2138C8.26518 6.48866 9.7723 8.64675 9.79334 9.10243C9.8032 9.31877 9.529 9.76525 9.32845 10.0914C9.04044 10.5602 8.81293 10.9298 8.90235 11.2428C9.13841 12.0673 9.71049 12.9629 10.512 13.7645C11.3471 14.5989 12.1895 15.1381 13.016 15.3669L13.0403 15.3735C13.0844 15.386 13.1317 15.3926 13.1804 15.3926C13.4553 15.3926 13.7761 15.194 14.1812 14.9422C14.5172 14.7337 14.9361 14.474 15.1669 14.474C15.6265 14.4944 17.8188 16.0265 18.0562 16.3447C18.0785 16.6202 17.4972 17.7644 16.3268 18.0392Z"
            fill="white"
        />
    </svg>
);

export default function Support() {
    const { t } = useLang('delta_pro_ultra.launch.detail.Support');

    return (
        <section className={`DPUSupport GtmModuleData-section`} id="Support" data-section-id={'DPUSupport'} data-section-title={t('title')}>
            <EfSpec />
            <div className="support-content">
                <h2 className="section-title">{t('title')}</h2>
                <div className="cards">
                    <FreeQuoteCard pillLabel={t('pill_left')}>
                        <div className="card card-freeQuote GtmModuleData-btn-common" data-btn-id="btn-freeQuote" role="button" tabIndex={0}>
                            <div className="card-body">
                                <h3 className="card-title">{t('left_title')}</h3>
                                <p className="card-desc">{t('left_desc')}</p>
                            </div>
                            <div className="card-image">
                                <EcoImg
                                    className="card-banner"
                                    pc="https://websiteoss.ecoflow.com/figma-uploads/1781492075872-s44f3k-compressed-Frame%201612708225.png"
                                    h5="https://websiteoss.ecoflow.com/figma-uploads/1781859339022-s4cz91-compressed-Mask%20group.jpg"
                                    isOpenLazy
                                />
                            </div>
                        </div>
                    </FreeQuoteCard>
                    <div className="card-col">
                        <EcoLink
                            className="pill"
                            href="https://www.ecoflow.com/us/remote-installation-video-support-form?utm_source=official&utm_medium=email&utm_campaign=remote_live_video_support"
                            target="_blank"
                        >
                            {t('pill_right')}
                        </EcoLink>
                        <div className="card">
                            <div className="card-body">
                                <h3 className="card-title">{t('right_title')}</h3>
                                <p className="card-desc">{t('right_desc')}</p>
                                <div className="contact">
                                    <a className="contact-item" href={`mailto:${t('email')}`}>
                                        <IconEmail />
                                        <span>
                                            {t('email_label')} <span className="contact-link">{t('email')}</span>
                                        </span>
                                    </a>
                                    <div className="contact-item">
                                        <IconPhone />
                                        <span>
                                            {t('phone_label')} {t('phone')}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="card-image">
                                <EcoImg
                                    className="card-banner"
                                    pc="https://websiteoss.ecoflow.com/figma-uploads/1781492210423-l9w77y-compressed-DPUX%2BDPU%203.png"
                                    h5="https://websiteoss.ecoflow.com/figma-uploads/1781859636223-7cun6b-compressed-Mask%20group.jpg"
                                    isOpenLazy
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <p className="disclaimer">{t('disclaimer')}</p>
            </div>
        </section>
    );
}
